/* EcológicoPet - Burbuja de despacho. Lee window.EPET_DELIVERY_CONFIG (mantenedor)
   con fallback a valores por defecto para no romperse nunca. */

function _epCfg() { return (typeof window !== 'undefined' && window.EPET_DELIVERY_CONFIG) || {}; }
function _epFeriados() { var c = _epCfg(); return (c.feriados && c.feriados.length) ? c.feriados : ['2026-06-29', '2026-05-21', '2025-06-29', '2026-07-16']; }
function _epDomHab() { var c = _epCfg(); return (c.domingos_habilitados && c.domingos_habilitados.length) ? c.domingos_habilitados : ['2025-05-04']; }
function _epCorte(dia) { var c = _epCfg(); var t = (c.cortes && c.cortes[dia]) || c.corte || '14:00'; var s = String(t).split(':'); var h = parseInt(s[0], 10); var m = parseInt(s[1], 10); return { h: isNaN(h) ? 14 : h, m: isNaN(m) ? 0 : m }; }
function _epDiaHabil(dia) { var c = _epCfg(); if (c.dias && typeof c.dias[dia] !== 'undefined') return !!c.dias[dia]; return dia >= 1 && dia <= 6; }

function getFechaSantiago(fecha = new Date()) {
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit' }).format(fecha);
}
function getHoraSantiago(fecha = new Date()) {
    const formatter = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
    const parts = formatter.formatToParts(fecha);
    const map = Object.fromEntries(parts.map(p => [p.type, p.value]));
    return `${map.hour}:${map.minute}:${map.second}`;
}
function getFechaCompletaSantiago(fecha = new Date()) {
    return new Date(`${getFechaSantiago(fecha)}T${getHoraSantiago(fecha)}`);
}

function esFeriado(fechaISO) { return _epFeriados().indexOf(fechaISO) !== -1; }
function esDomingoHabilitado(fechaISO) { return _epDomHab().indexOf(fechaISO) !== -1; }

function esDiaDespacho(fecha) {
    const fechaStr = getFechaSantiago(fecha);
    const dia = fecha.getDay();
    if (esFeriado(fechaStr)) return false;
    if (dia === 0) return _epDiaHabil(0) || esDomingoHabilitado(fechaStr);
    return _epDiaHabil(dia);
}

function obtenerProximoDiaHabil(fechaISO) {
    let fecha = new Date(`${fechaISO}T00:00:00`);
    for (let i = 0; i < 400; i++) {
        fecha.setDate(fecha.getDate() + 1);
        if (esDiaDespacho(fecha)) return getFechaSantiago(fecha);
    }
    return getFechaSantiago(fecha);
}

function mensajeProximoHabil(hoyISO, proximoISO) {
    const hoy = new Date(`${hoyISO}T00:00:00`);
    const manana = new Date(hoy);
    manana.setDate(manana.getDate() + 1);
    const mananaISO = getFechaSantiago(manana);
    if (proximoISO === mananaISO) return 'Llega <span class="remaining-time">MAÑANA</span>';
    const diaSemana = ["DOMINGO", "LUNES", "MARTES", "MIÉRCOLES", "JUEVES", "VIERNES", "SÁBADO"];
    const dia = new Date(`${proximoISO}T00:00:00`).getDay();
    return `Llega el <span class="remaining-time">${diaSemana[dia]}</span>`;
}

function formatCountdown(ms) {
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    const s = Math.floor((ms % 60000) / 1000);
    const pad = n => n.toString().padStart(2, '0');
    return `${pad(h)}h ${pad(m)}m ${pad(s)}s`;
}

function updateCountdown(cutOffTime, element) {
    let intervalId = null;
    const tick = () => {
        // Guardia: si el elemento ya no existe o se desconectó del DOM (por re-render dinámico
        // de secciones / MutationObserver), detener el intervalo y no escribir. Evita el error
        // "Cannot set properties of undefined (setting 'innerHTML')" que se repetía cada segundo.
        if (!element || !element.isConnected) { if (intervalId) clearInterval(intervalId); return; }
        const now = getFechaCompletaSantiago();
        let diff = cutOffTime - now;
        diff = Math.max(diff, 0);
        if (diff <= 0) {
            const hoyISO = getFechaSantiago(now);
            const proximo = obtenerProximoDiaHabil(hoyISO);
            element.innerHTML = mensajeProximoHabil(hoyISO, proximo);
            element.dataset.initialized = "true";
            if (intervalId) clearInterval(intervalId);
            return;
        }
        element.innerHTML = "¡Llega HOY!<br><span class='santiago'>Aún estás a tiempo:</span><br>" +
            `<span class='remaining-time'>${formatCountdown(diff)}</span>`;
    };
    tick();
    intervalId = setInterval(tick, 1000);
}

function deliveryMessage2() {
    const elements = document.querySelectorAll(".delivery-message2");
    elements.forEach((element) => {
        if (element.dataset.initialized) return;
        const now = getFechaCompletaSantiago();
        const hoyISO = getFechaSantiago(now);
        const cutOffTime = new Date(now);
        const corte = _epCorte(now.getDay());
        cutOffTime.setHours(corte.h, corte.m, 0, 0);

        const despachaHoy = esDiaDespacho(now);
        if (despachaHoy && now <= cutOffTime) {
            updateCountdown(cutOffTime, element);
        } else {
            const proximo = obtenerProximoDiaHabil(hoyISO);
            element.innerHTML = mensajeProximoHabil(hoyISO, proximo);
        }
        element.dataset.initialized = "true";
    });
}

deliveryMessage2();

const observer = new MutationObserver(() => { deliveryMessage2(); });
observer.observe(document.body, { childList: true, subtree: true });

function iniciarReintentosDinamicos() {
    const reintento = setInterval(() => {
        const pendientes = document.querySelectorAll('.delivery-message2:not([data-initialized])');
        if (pendientes.length > 0) deliveryMessage2();
    }, 500);
    setTimeout(() => clearInterval(reintento), 20000);
}
document.addEventListener('DOMContentLoaded', iniciarReintentosDinamicos);
document.addEventListener('shopify:section:load', () => { deliveryMessage2(); iniciarReintentosDinamicos(); });
